// extracted by mini-css-extract-plugin
export default {"overlayWrapper":"InventorySearch_overlayWrapper__pLs61","mainInputContainer":"InventorySearch_mainInputContainer__ZVwg1","resultContainer":"InventorySearch_resultContainer__8tUgj"};